import { useUrlParams } from 'src/utils/use-url-params';

export const getAgentUserSearchParams = (
    rawSearchParams: URLSearchParams,
    parsedSearchParams: ReturnType<typeof useUrlParams>
): URLSearchParams | null => {
    const agentSearchParams = new URLSearchParams();
    const agentUrlDetails = {
        firstName: parsedSearchParams.firstName,
        lastName: parsedSearchParams.lastName,
        preferredName: parsedSearchParams.preferredName,
        email: parsedSearchParams.email,
        callingCode: parsedSearchParams.callingCode,
        phone: parsedSearchParams.phone,
        address1: parsedSearchParams.address1,
        address2: parsedSearchParams.address2,
        city: parsedSearchParams.city,
        postCode: parsedSearchParams.postCode,
        country: rawSearchParams.get('country'),
        dob: parsedSearchParams.dob,
        university: parsedSearchParams.parsedUniversity,
    };

    const existingAgentDetails = Object.entries(agentUrlDetails).filter(([, value]) =>
        Boolean(value)
    ) as [string, string][];

    if (!existingAgentDetails.length) {
        return null;
    }

    existingAgentDetails.map(([key, value]) => agentSearchParams.set(key, value));

    return agentSearchParams;
};
